import {useContext} from "react";
import {UserAttributesContext} from "../context/UserAttributesContext.tsx";

export const useUserAttributes = () => {
    return useContext(UserAttributesContext);
}
